// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  userId: __t.string().name("user_id"),
  orgId: __t.string().name("org_id"),
  kind: __t.string(),
  projectId: __t.string().name("project_id"),
  projectName: __t.string().name("project_name"),
  commentId: __t.string().name("comment_id"),
  actorName: __t.string().name("actor_name"),
  actorAvatar: __t.string().name("actor_avatar"),
  title: __t.string(),
  body: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  readAt: __t.option(__t.timestamp()).name("read_at"),
  inApp: __t.bool().name("in_app"),
  emailStatus: __t.string().name("email_status"),
  emailAt: __t.timestamp().name("email_at"),
  assetId: __t.string().name("asset_id"),
});
